export default "__VITE_ASSET__DOqi_9XE__"